import { Action, Types } from "./tabbar.actions"

export type TabbarState = {
  index: number
}

const initialState: TabbarState = {
  index: 0,
}

export default (state = initialState, action: Action): TabbarState => {
  switch (action.type) {
    case Types.UPDATE:
      return {
        ...state,
        index: action.payload.index,
      }

    default:
      return state
  }
}
